import { useMemo } from 'react'
import { ChainId, Native, NativeCurrency } from '@nominex/nomiswap-sdk'
import { useWagmi } from 'libs/wagmi'

export default function useNativeCurrency(): NativeCurrency {
  const { chainId } = useWagmi()

  return useMemo(() => {
    try {
      return Native.onChain(chainId)
    } catch (e) {
      return Native.onChain(ChainId.BSC)
    }
  }, [chainId])
}
